import React, { useEffect, useRef, useState } from 'react';

interface RevealProps {
  children: React.ReactNode;
  delay?: number;
  as?: keyof JSX.IntrinsicElements;
  className?: string;
  id?: string;
  style?: React.CSSProperties;
}

export const Reveal: React.FC<RevealProps> = ({
  children,
  delay = 0,
  as: Tag = 'div',
  className = '',
  id,
  style,
}) => {
  const ref = useRef<HTMLElement | null>(null);
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const r = el.getBoundingClientRect();
    if (r.top < window.innerHeight && r.bottom > 0) {
      const t = setTimeout(() => setShown(true), delay);
      return () => clearTimeout(t);
    }

    let cancelled = false;
    const reveal = () => {
      if (!cancelled) setTimeout(() => setShown(true), delay);
    };

    if (typeof IntersectionObserver !== 'undefined') {
      const io = new IntersectionObserver(
        ([e]) => {
          if (e && e.isIntersecting) {
            reveal();
            io.disconnect();
          }
        },
        { threshold: 0.05, rootMargin: '0px 0px -20px 0px' }
      );
      io.observe(el);
      const fb = setTimeout(reveal, 1200);
      return () => {
        cancelled = true;
        io.disconnect();
        clearTimeout(fb);
      };
    }

    reveal();
    return () => {
      cancelled = true;
    };
  }, [delay]);

  const Component = Tag as any;
  return (
    <Component ref={ref} id={id} className={`reveal ${shown ? 'in' : ''} ${className}`.trim()} style={style}>
      {children}
    </Component>
  );
};
